import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";
import PropTypes from "prop-types";
import toastAlert from "../../js/Base/ToastAlert";
import { getProjectsByAcctId } from "../../api/projectApi";

const ProjectSelector = ({
  projectSelect = () => {},
  style = {},
  disabled = false,
}) => {
  const [projectId, setProjectId] = useState(
    localStorage.getItem("project_uuid")
      ? localStorage.getItem("project_uuid")
      : ""
  );
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const getProjectsByAcct = async () => {
      const userUuid = localStorage.getItem("user_uuid");
    
      if (!userUuid) {
        toastAlert.autoClose(true).showError("查無資料，請聯絡系統管理員");
        return;
      }
    
      try {
        const response = await getProjectsByAcctId(userUuid);
        const data = response.data;
    
        if (!data.success) {
          toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
          return;
        }
    
        setProjects(data.projects || []);
    
        // 如果 localStorage 有 project_id，通知父層
        if (projectId) {
          projectSelect(projectId);
        }
    
      } catch (error) {
        if (error.__handled) return;    
        toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
      }
    };
  getProjectsByAcct();
}, [projectId, projectSelect]);

  const handleChangeProject = (newProjectId) => {
    const uid = newProjectId;
    setProjectId(uid);

    if (!uid) {
      localStorage.removeItem("project_id");
      localStorage.removeItem("project_uuid");
      localStorage.removeItem("project_name");
      projectSelect(null);
      return;
    }

    const project = projects.find((p) => p.uid === uid);
    if (project) {
      localStorage.setItem("project_id", project.id);
      localStorage.setItem("project_uuid", project.uid);
      localStorage.setItem("project_name", project.name);

      if (project.company_id || project.company_uuid) {
        localStorage.setItem("company_id", project.company_id);
        localStorage.setItem("company_uuid", project.company_uuid);
      }
    }

    projectSelect(uid);
  };

  return (
    <React.Fragment>
      <Input
        type="select"
        name="select"
        onChange={(e) => handleChangeProject(e.target.value)}
        value={projectId}
        // style={style || {}}
        style={{
          ...style,
          outline: 'none',
          boxShadow: 'none',
        }}
        disabled={!!disabled}
      >
        {projects.map((p) => (
          <option key={p.id} value={p.uid}>
            {p.name}
          </option>
        ))}
      </Input>
    </React.Fragment>
  );
};

ProjectSelector.propTypes = {
  projectSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  style: PropTypes.object,
};

export default ProjectSelector;
